import type { LocationComparison } from '@/types/patterns';

interface LocationComparisonInsightProps {
  comparison: LocationComparison;
}

export function LocationComparisonInsight({ comparison }: LocationComparisonInsightProps) {
  const { locations } = comparison;

  return (
    <div
      className="bg-[var(--color-surface)] border border-[var(--color-border)] rounded-lg p-3"
      data-testid="location-comparison-insight"
    >
      <p className="field-label mb-3">
        Location Comparison
      </p>
      <div className="flex flex-col gap-2.5">
        {locations.map((loc) => {
          const pct = Math.round(loc.observationRate * 100);
          return (
            <div key={loc.waypointId} data-testid={`location-bar-${loc.waypointId}`}>
              <div className="flex items-center justify-between mb-0.5">
                <span className="text-body-xs text-[var(--color-text-secondary)] truncate mr-2">{loc.waypointName}</span>
                <span className="text-body-xs text-[var(--color-text-placeholder)] shrink-0">
                  {pct}% ({loc.observationVisits} of {loc.totalVisits})
                </span>
              </div>
              <div className="h-1.5 rounded-full bg-[var(--color-elevated)] overflow-hidden">
                <div
                  className="h-full rounded-full bg-[var(--color-accent)] transition-all"
                  style={{ width: `${pct}%` }}
                  aria-hidden="true"
                />
              </div>
            </div>
          );
        })}
      </div>
      <p className="text-body-xs text-[var(--color-text-placeholder)] mt-2.5" data-testid="sample-size">
        Observation rate across your scouting visits
      </p>
    </div>
  );
}
